import React from 'react';
import { InputAdornment, TextFieldProps } from '@material-ui/core';
import { SearchIcon } from '../SVGIcons';
import { TableHeadTextField } from './style';

interface TableHeadSearchFieldProps extends Omit<TextFieldProps, 'InputProps' | 'onChange' | 'label'> {
    onChange?(val: string): void;
}

const TableHeadSearchField = ({ placeholder, value, onChange }: TableHeadSearchFieldProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.value);
        }
    };

    return (
        <TableHeadTextField
            margin='dense'
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            InputProps={{
                disableUnderline: true,
                endAdornment: (
                    <InputAdornment position='end'>
                        <SearchIcon fontSize='small' />
                    </InputAdornment>
                )
            }}
        />
    );
};

export default TableHeadSearchField;
